// extracted by mini-css-extract-plugin
export default {"main":"OrderFeed_main__ZeLTd"};